import React, { Fragment, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import { useGetDraftUsersQuery, useUpdateDraftUserMutation } from '../../features/draftusers/draftUsersApiSlice';
import useAuth from '../../features/hooks/useAuth';
import Popup from 'reactjs-popup';
import { useAddNewUserMutation, useApproveNewUserMutation, useGetUsersQuery, useUpdateUserMutation } from '../../features/users/usersApiSlice';
import moment from "moment";
import { useGetjoinoffreqQuery, useUpdatejoinoffreqMutation } from '../../features/joinoffreq/joinOffReqApiSlice';
import ApproveUserModal from './ApproveUserModal';
import { useGetofficesQuery, useUpdateofficeMutation } from '../../features/offices/officesApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import compareObjects from '../../data/compareObjects';
import ExcelDownload from '../../data/exceldownload';
import {TableContStyle, TableHeadStyle } from '../../Styles/TableStyles';




const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  justify-content: flex-end;
  margin:10px;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`
const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


const ApproveUsers = () =>{
  const userChangeInitial = {
    userId:"", email:"", mainOffice:"", designation:"", changeType:"", changeArray:[],
    changeObject:{
        name:{previous:{firstName: "",middleName: "",lastName: ""},afterChange:{firstName: "", middleName: "", lastName: ""}},
        mobileNo:{previous:"", afterChange:""},
        officeLandLine:{previous:"", afterChange:""},
        employeeID:{previous:"", afterChange:""},
        officeAddress:{previous:"",afterChange:""},
        office:{previous:{mainCharge: "", additionalCharge: []}, afterChange:{mainCharge: "", additionalCharge: []}},
        designation:{previous:{}, afterChange:{}},
        designationSuffix:{previous:{},afterChange:{}},
        numSuffix:{previous:{},afterChange:{}},
        roles:{previous:{main: []},afterChange:{main: []}},
        assets: {previous:[],afterChange:[]},
        bo_assets: {previous:[],afterChange:[]},
        store_assets: {previous:[],afterChange:[]},
    },
    timeStamp:new Date(Date.now()).toISOString()
  }


  const Auth = useAuth();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); // Initial state is enabled
  const [tabledata, setTabledata]= useState([]);
  const [approvemodalopen, setApprovemodalopen] = useState(false);
  const [approveModaldata, setApproveModaldata] = useState({});
  const [downloadData, setDownloadData] = useState({});
  const [userChangeDoc, setUserChangeDoc] = useState(userChangeInitial);



  const [updateDraftuser] = useUpdateDraftUserMutation();
  const [approveNewUser] = useApproveNewUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const [updateOffice] = useUpdateofficeMutation();
  const [updateJoinOff] = useUpdatejoinoffreqMutation();

  const {offices} =  useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })
  
 const {draftusers} = useGetDraftUsersQuery("draftusersList", {
    selectFromResult: ({ data }) => ({
        draftusers: data?.entities
    }),
  })
  const {joinoffcreq} = useGetjoinoffreqQuery("joinoffcreq",{
    selectFromResult: ({ data }) => ({
      joinoffcreq: data?.entities
    }),
  })

  const {users} = useGetUsersQuery("users", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  }
  )
  const tableFontSize = 14;

  useEffect(() => {
    if(draftusers && joinoffcreq){
      let finalArray = []
      const keyArray = ["id", "email", "password","name", "office", "designation","mobileNo", "officeLandLine", "employeeID","officeAddress", "designationSuffix", "numSuffix","reqType", "submissionDate","approvalDate", "roles", "status", "currentOffice","chargeType", "active" ];
      const combinedArray = Object.values(draftusers).concat(Object.values(joinoffcreq));
      for(let value of combinedArray){
        let tempObject = {}
        if(value?.status !== "signup_requested"){
          for(let val of keyArray){
              tempObject = {...tempObject, [val]:value[val]};
          }
          finalArray.push(tempObject);
        }
      }
      setTabledata(finalArray.sort((a, b) => new Date(b.submissionDate) - new Date(a.submissionDate)));
      }
  }, [draftusers, joinoffcreq])
  console.log(tabledata)

  const initialUserState = {
    name:{firstName:"", middleName:"", lastName:""},
    email:"",
    password: "",
    mobileNo:"",
    officeLandLine:"",
    employeeID: "",
    officeAddress:"",
    office: {mainCharge:"", additionalCharge:[]},
    designation:{},
    designationSuffix:{},
    numSuffix:{},
    roles:{main:["user"]},
    assets:{},
    indi_assets:[],
    bo_assets:{},
    store_assets:{},
    active:true
}

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };  

  const handleApproveModal = (e,row) => {
    let userObject = {};
    if (row.reqType === "joinoffreq"){
      userObject = Object.values(users).find(x => x.email === row.email)
    }
    const tempData = {"type":e.target.name,"row":row,"userObject":userObject}
    setApproveModaldata(tempData)
    setApprovemodalopen(true)
  }

  const handleApproveModalClose = () =>{
    setApprovemodalopen(false);
  }
  
  const handleApproveFormSubmit = async (e) => {
    e.preventDefault();
    console.log("Entered");
    try{
      let userId = ""
      //tempUSer is the userdetails with modified data as per request
      const tempUser = approveModaldata?.row;
      //currentUser is the current state of user.
      const currentUser = approveModaldata?.userObject;
      //Relieved Offices are offices proposed to be relieved
      const relievedOffices = [currentUser?.office?.mainCharge].concat(currentUser?.office?.additionalCharge).filter(x => ![tempUser?.office?.mainCharge].concat(tempUser?.office?.additionalCharge).includes(x));
      //new Offices are offices proposed to be addedd.
      const newOffices = [tempUser.office?.mainCharge].concat(tempUser.office?.additionalCharge).filter(x => [currentUser.office?.mainCharge].concat(currentUser.office?.additionalCharge).includes(x));
      const unitHeadOfficeArray = Object.entries(tempUser.roles).filter(x => x[1].includes("UnitHead")).map(y => y[0]);
      console.log(unitHeadOfficeArray);
      let finalObject = {};
      if(approveModaldata.row.reqType === "signupreq"){
        console.log("first")
        for(let key in initialUserState){
          if(key in tempUser){
            finalObject[key] = tempUser[key];
          }else{
            finalObject[key] = initialUserState[key];
          }
        }
        if(!window.confirm(`Are you sure want to Approve `)){
          return;
        };
        const resultNewUser = await approveNewUser(finalObject)
        userId = resultNewUser.data.createdId;
        console.log(userId)
          const {password, _id, ...rest} = tempUser;
          let body ={...rest, "status":"signup_approved", "approvalDate": new Date(Date.now()).toISOString() }
          const res = await  updateDraftuser(body);
          console.log(res)
          alert("User has been approved successfully")
      }
      if(approveModaldata.row.reqType === "joinoffreq" ){
        let joinOffDocument = structuredClone(Object.values(joinoffcreq)?.find(x => x._id === approveModaldata?.row.id));
        console.log(joinOffDocument)
        console.log("second")
        userId = currentUser["id"];
        for(let key in currentUser){        
          if(key in tempUser){
            finalObject[key] = tempUser[key];
          }
        }
        finalObject["id"] = currentUser["id"];

        if(!window.confirm(`Are you sure want to Approve `)){
          return;
        };
        // for(const val of relievedOffices){
        //   if(currentUser?.assets?.[val]?.length){
        //     return alert(`Assets have not been handed over from ${val} office`);
        //   }
        //   if(currentUser?.bo_assets?.[val]){
        //     return alert(`BO Assets have not been handed over from ${val} office`);
        //   }
        //   if(currentUser?.store_assets?.[val] ){
        //     return alert(`Store Assets have not been handed over from ${val} office`);
        //   }  
        // }
        console.log("Moved Forward")
        const result = await updateUser(finalObject)
        console.log(result)
        joinOffDocument["status"] = "joinnewoff_approved";
        joinOffDocument["approvalDate"] = new Date(Date.now()).toISOString();
        const {_id, ...body} = joinOffDocument;
        const resultJoinOffReq = await updateJoinOff(body);
        console.log(resultJoinOffReq);
      }
      for(let office of unitHeadOfficeArray ){
        let tempOffObj = structuredClone(Object.values(offices)?.find( x => x.name === office));
        console.log(tempOffObj)
        tempOffObj.unitHead = userId;
        const {_id, ...body}  = tempOffObj;
        console.log(body)
        const res = await updateOffice(body);
        console.log(res)
      }
    } catch(err){
      console.log(err)
    }
    
    
  //  //The code below is for creating Object for Change User Database
  //   let tempUserChangeDoc = structuredClone(userChangeDoc);
  //   tempUserChangeDoc.userId = currentUser.id;
  //   tempUserChangeDoc.email = approveModaldata.row.email;
  //   tempUserChangeDoc.mainOffice = currentUser.office.mainCharge;
  //   tempUserChangeDoc.designation = currentUser.designation[tempUserChangeDoc.mainOffice];
  //   // && approveModaldata.row.reqType !== "signupreq"
  //   if(relievedOffices.length ){
  //     if(newOffices.length){
  //       tempUserChangeDoc.changeType = "Join and Relieve Office";
  //     }else{
  //       tempUserChangeDoc.changeType = "Relieve Office";
  //     }
  //   }else{
  //     if(newOffices.length){
  //       tempUserChangeDoc.changeType = "Join Office";
  //     }
  //   }
  //   tempUserChangeDoc.changeArray.push("office", "designation");
  //   tempUserChangeDoc.changeObject.office.previous = currentUser.office;
  //   tempUserChangeDoc.changeObject.office.afterChange = finalObject.office;
  //   tempUserChangeDoc.changeObject.designation.previous = currentUser.designation;
  //   tempUserChangeDoc.changeObject.designation.afterChange = finalObject.designation;
  //   for(let key in tempUserChangeDoc.changeObject){
  //     if(!tempUserChangeDoc.changeArray.includes(key)){
  //       delete tempUserChangeDoc.changeObject[key]
  //     }
  //   }
    setApprovemodalopen(false);
  }

  return (
    <>
      <HeadingWrap>
        <Span>User Approval Request</Span>
      </HeadingWrap>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"myUsers"} sheetName={"sheet1"}/>
      </Button2Div> 
     <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor, width:"98%", marginLeft:"10px" }}  >
      <Table  sx={{ minWidth: 500 }} aria-label="custom pagination table">
      <TableHead style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}}>Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Name</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">email</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Designation</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Office</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Req Type</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Request Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Approval Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Status</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Accept/Reject</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {draftusers && (rowsPerPage > 0
          ? tabledata?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <TableRow key={key}>
              {console.log(row)}
                <TableCell sx={{ fontSize: tableFontSize}}>{(rowsPerPage*page)+key+1}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{`${row.name.firstName} ${row.name.middleName} ${row.name.lastName} `}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.email }</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.reqType === "joinoffreq"? row.designation[row.currentOffice]:row.designation[row.office.mainCharge]}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.reqType === "joinoffreq"? row.currentOffice:row.office.mainCharge}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.reqType}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.submissionDate? moment(row.submissionDate).format('DD/MM/YYYY'):"NA"}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row?.approvalDate?.length? moment(row.approvalDate).format('DD/MM/YYYY'):"Not Available"}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left">{row.status}</TableCell>
                <TableCell sx={{ fontSize: tableFontSize}} align="left" >
                <ButtonWrapper>
                  <SubmitButton name='approve' type='button' disabled={["signup_approved", "joinnewoff_approved"].includes(row.status)} onClick={(e) => handleApproveModal(e, row)} style= {["signup_approved", "joinnewoff_approved"].includes(row.status)? {backgroundColor: "#CCCCCC"}:{backgroundColor: "008080"}}>Approve
                  </SubmitButton>
                  <SubmitButton name='reject' type='button' disabled={["signup_approved", "joinnewoff_approved"].includes(row.status)} onClick={(e) => handleApproveModal(e, row)} style={{backgroundColor:"#D32F2F"}}>Reject
                </SubmitButton>
                </ButtonWrapper>                                 
                </TableCell>
            </TableRow>                 
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={draftusers? Object.values(draftusers)?.length:null}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    <ApproveUserModal
      approvemodalopen = {approvemodalopen}
      approveModaldata = {approveModaldata}
      handleApproveModalClose = {handleApproveModalClose}
      handleApproveFormSubmit = {handleApproveFormSubmit}    
    />
    </>

   
  );
}

export default ApproveUsers;